/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import {cloneDeep} from "lodash";
import * as yup from 'yup';

const handleQuestionsInitialAdjustments = ({
                                             questionnaire
                                           }) => {
  return questionnaire.map(question => {
    return question;
  })
};

const groupMultipleFieldQuestions = ({
                                       mainIdQuestion,
                                       questionnaire,
                                       handleQuestionsInitialAdjustments
                                     }) => {
  const groupQuestions = [];

  const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
  for (const mainQuestion of mainQuestions) {
    let group = []

    const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
    if (mainQuestionIndex || mainQuestionIndex == 0) group.push(questionnaire[mainQuestionIndex]);

    if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);

    if (mainQuestion.childrenQuestions) mainQuestion.childrenQuestions.map(childQuestion => group.push(childQuestion));

    group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    if (handleQuestionsInitialAdjustments) group = handleQuestionsInitialAdjustments({questionnaire: group});

    groupQuestions.push(group.map((question, index) => ({...question, key: null})));
  }

  return groupQuestions;
}

function handleSave({
                      values,
                      emailContentGroup,
                      SECTIONS,
                      refQuestionnaireSent,
                      submitFunction,
                      useGetQuestionnaireAnswerRequest,
                      useSaveQuestionnaireAnswerRequest
                    }) {
  buildValidation({
    values,
    emailContentGroup,
    SECTIONS
  }).validate(values, {abortyEarly: false}).then(() => {
    const isValidSubmittedForm = handleValidationsSubmittedForm({})

    if (isValidSubmittedForm) {
      handleSubmit({
        values,
        emailContentGroup,
        onlyQuestions: false,
        SECTIONS,
        refQuestionnaireSent,
        submitFunction,
        useGetQuestionnaireAnswerRequest,
        useSaveQuestionnaireAnswerRequest,
      })
    }
  })
}

function handleValidationsSubmittedForm({}) {
  return true
}

function buildValidation({
                           values,
                           emailContentGroup,
                           SECTIONS
                         }) {
  const validationSchema = {};

  const validationQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    emailContentGroup,
    SECTIONS,
    onlyQuestions: true
  });

  let allQuestions = [...validationQuestionnaire];
  for (const question of allQuestions) {
    if (question.childrenQuestions?.length) allQuestions = [...allQuestions, ...question.childrenQuestions]
  }

  for (const question of allQuestions) {
    if ([614].includes(question?.idDomainQuestion)) continue;
    if (!question?.key) continue;

    question?.childrenQuestions?.map(item => {
      if (item.visibleQuestion && item.fieldMask?.type == 'phone' && item.behaviorObject?.isRequired) {
        validationSchema[item.key] = yup.string().test({
          name: "answer-validation",
          message: "Invalid phone",
          test: (value) => !!value && value.length >= 10
        })
      } else if (item.visibleQuestion && item.behaviorObject?.fieldMask == 'email') {
        if (item.answer) {
          validationSchema[item.key] = yup.string().email('Invalid email').required("Required field")
        } else {
          if (item.behaviorObject?.isRequired) {
            validationSchema[item.key] = yup.string().email("Invalid email").required("Required field")
          } else {
            validationSchema[item.key] = yup.string().notRequired();
          }
        }
      } else {
        validationSchema[item.key] = item.visibleQuestion && item.behaviorObject?.isRequired
          ? yup.string().test("answer-validation", "Required field", function (value) {
            return !!item.answer;
          }) : yup.string().notRequired();
      }
    })

    if (question.visibleQuestion && question.behaviorObject?.isRequired && question.fieldMask?.type == 'phone') {
      validationSchema[question.key] = yup.string().test({
        name: "answer-validation",
        message: "Invalid phone",
        test: (value) => !!value && value.length >= 10
      })
    } else if (question.visibleQuestion && question.behaviorObject?.fieldMask == 'email') {
      if (question.answer) {
        validationSchema[question.key] = yup.string().email("Invalid email").required("Required field")
      } else {
        if (question.behaviorObject?.isRequired) {
          validationSchema[question.key] = yup.string().email("Invalid email").required("Required field")
        } else {
          validationSchema[question.key] = yup.string().notRequired();
        }
      }
    } else {
      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().test("answer-validation", "Required field", function (value) {
          return !!question.answer;
        }) : yup.string().notRequired();
    }
  }

  return yup.object().shape(validationSchema);
}

function handleQuestionnaireAnswerToSave({
                                           values,
                                           emailContentGroup,
                                           SECTIONS,
                                           onlyQuestions
                                         }) {
  const formValues = JSON.parse(JSON.stringify(values)) || {};

  let questionnaireAnswers = [];

  for (const [, section] of Object.entries(SECTIONS)) {
    if (section.isMultiple) {
      let multipleFields = [];
      switch (section.name) {
        case 'PARTIES_EMAIL_INFO':
          multipleFields = cloneDeep(emailContentGroup);
          break;
        default:
          multipleFields = [];
          break;
      }

      multipleFields.map((field, index) => {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
        if (sectionAnswers?.length) {
          const rootQuestion = sectionAnswers.find((question) => !question.idQuestionRoot);
          const childrenQuestions = sectionAnswers.filter((question) => question.idQuestionRoot);
          rootQuestion.childrenQuestions = childrenQuestions;
          if (!onlyQuestions) {
            questionnaireAnswers = [...questionnaireAnswers, rootQuestion];
          } else {
            questionnaireAnswers = [...questionnaireAnswers, ...sectionAnswers];
          }
        }
      });
    }
  }

  let childrenQuestionIds = [];
  for (const question of questionnaireAnswers) {
    if (question) {
      if (
        (question.idDomainQuestion === 270 ||
          question.idDomainQuestion === 271 ||
          (question.idDomainQuestion === 44 && typeof question.answer === 'object')
        ) && question.answer
      ) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }

      if (SECTIONS[question.behaviorObject?.sectionName] && SECTIONS[question.behaviorObject?.sectionName].isMultiple) {
        if (question?.childrenQuestions?.length) {
          const idQuestions = question.childrenQuestions.map(question => question.idQuestion);
          childrenQuestionIds = [...childrenQuestionIds, ...idQuestions];
        }
      } else {
        question.childrenQuestions = [];
      }
    }
  }

  questionnaireAnswers = questionnaireAnswers.filter(v => !childrenQuestionIds.includes(v.idQuestion))

  return questionnaireAnswers;
}

function handleSubmit({
                        values,
                        emailContentGroup,
                        onlyQuestions,
                        SECTIONS,
                        refQuestionnaireSent,
                        useGetQuestionnaireAnswerRequest,
                        useSaveQuestionnaireAnswerRequest,
                        submitFunction
                      }) {
  if (refQuestionnaireSent.current) return;


  refQuestionnaireSent.current = true;

  const validQuestionnaire = handleQuestionnaireAnswerToSave({
    values,
    emailContentGroup,
    SECTIONS,
    onlyQuestions
  });

  useSaveQuestionnaireAnswerRequest(validQuestionnaire)
    .then((resp) => {
      refQuestionnaireSent.current = false;
      if (resp.status === 200) {
        useGetQuestionnaireAnswerRequest();

        if (submitFunction) {
          submitFunction();
        }
      }
    })
}

const events = {
  handleQuestionsInitialAdjustments,
  groupMultipleFieldQuestions,
  handleSave,
  handleSubmit
};

export {events};